import { Outlet, Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

// Mesma checagem de autenticacao do Layout normal, mas sem a Navbar — usado pelas telas "tela
// cheia" pensadas pra abrir numa aba a parte (ex.: /parcelas-atraso/tela-cheia).
export default function LayoutSemNavbar() {
  const { usuario, loading } = useAuth()
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>Carregando...</div>
  if (!usuario) return <Navigate to="/login" />
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <Outlet />
    </div>
  )
}
